
import { EventParticipantsProps } from '../../components/screens/EventParticipantsPage/EventParticipantsProps';
import {
    TOGGLE_PERSONAL_INFO_POPUP,
    TOGGLE_COMMUNITY_POPUP,
    SET_RESULT_TYPE_AMOUNT,
    SET_SEARCH_FILTER,
    SET_SIDEBAR_ROUTE_DATA,
    SET_CURRENT_COURSE,
    SET_CURRENT_PAGE,
    SET_CURRENT_COMMUNITY_ID,
    SET_CURRENT_EVENT,
    SET_CURRENT_PARTICIPANTS,
} from '../actions/mainActions';


export const resultTypeAmount = [
    {
        type: "Articles",
        amount: 0,
    },
    {
        type: "Source Sheets",
        amount: 0,
    },
    {
        type: "Events",
        amount: 0
    },
    {
        type: "Classes",
        amount: 0
    },
    // {
    //     type: "Friends",
    //     amount: 0
    // },
    // {
    //     type: "Communities",
    //     amount: 0
    // }

]

const initialState: MainReducerState = {
    showPersonalInfoPopup: false,
    showCommunityPopup: false,
    resultTypeAmount: resultTypeAmount,
    searchFilter: undefined,
    sidebarRouteData: {},
    currentCourse: undefined,
    currentEvent: undefined,
    currentParticipantsEvent: undefined,
    currentPage: "",
    currentCommunityId: null
}



const mainReducer = (state = initialState, action: any) => {
    switch (action.type) {

        case SET_CURRENT_PAGE:
            return {
                ...state,
                currentPage: action.value
            }

        case TOGGLE_PERSONAL_INFO_POPUP:
            return {
                ...state,
                showPersonalInfoPopup: action.value,
            }
        case SET_CURRENT_COURSE:
            return {
                ...state,
                currentCourse: action.value
            }
        case SET_CURRENT_EVENT:
            return {
                ...state,
                currentEvent: action.value
            }
        case SET_CURRENT_PARTICIPANTS:
            return {
                ...state,
                currentParticipantsEvent: action.value
            }
        case TOGGLE_COMMUNITY_POPUP:
            return {
                ...state,
                showCommunityPopup: action.value,
            }

        case SET_SIDEBAR_ROUTE_DATA:
            return {
                ...state,
                sidebarRouteData: { ...action.value }
            }

        case SET_RESULT_TYPE_AMOUNT:
            return {
                ...state,
                resultTypeAmount: action.value
            }
        case SET_SEARCH_FILTER:
            return {
                ...state,
                searchFilter: action.value
            }

        case SET_CURRENT_COMMUNITY_ID:
            return {
                ...state,
                currentCommunityId: action.value
            }
        default:
            return state;
    }
}

export interface MainReducerState {
    showPersonalInfoPopup: boolean
    showCommunityPopup: boolean
    resultTypeAmount: ResultTypeAmount[]
    searchFilter: string | undefined
    sidebarRouteData: any
    currentCourse: any
    currentEvent: any
    currentParticipantsEvent: EventParticipantsProps,
    currentPage: string
    currentCommunityId: any
}

export interface ResultTypeAmount {
    type: string;
    amount: number;
    originalType?: any;
}


export default mainReducer;